<template>
  <page-outline
    class="page"
    :title="$t('Webheader.rtp_global_settings')"
    colWidth="6"
  >
    <template slot="pageContent">
      <spinner v-if="activateSpinner"></spinner>
      <div v-else>
        <div class="ml-2 mt-xl-0">
          <b-button-group class="">
            <b-button :variant="tabName === 0 ? 'primary' : ''" @click="tabName = 0; resetSettings()">{{ $t('settings.global_label') }}</b-button>
            <b-button v-if="canSeeSRTP" :variant="tabName === 1 ? 'primary' : ''" @click="tabName = 1; resetSettings()">{{ $t('settings.eba_label') }}</b-button>
            <b-button v-if="canSeeHRTP" :variant="tabName === 2 ? 'primary' : ''" @click="tabName = 2; resetSettings()">{{ $t('settings.giro_label') }}</b-button>
            <b-button v-if="canSeePSD2" :variant="tabName === 3 ? 'primary' : ''" @click="tabName = 3; resetSettings()">{{ $t('common.norm.psd2') }}</b-button>
          </b-button-group>
        </div>
        <b-tabs v-model="tabName" class="mt-3" nav-class="d-none">
          <!--GENERAL SETTINGS-->
          <b-tab>
            <form-accordion :title="$t('settings.general_sttngs')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-write-group-label-input
                    v-model="settings['RTPMaxLinesExport']" :disabled="!doesEdit" :key="'maxLine'+resetInput"
                    :maxLength="21"
                    inputType="number"
                    :inputLabel="$t('settings.max_lines_export')"
                    horizontal
                    @input="changeMaxLinesExportRTP">
                  </form-write-group-label-input>
                </b-col>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-write-group-label-input
                    inputType="other" :key="'environment'+resetInput"
                    inputClass="inputParentFormWriteGroup"
                    :inputLabel="$t('settings.environnment_type')"
                    horizontal>
                      <select autocomplete="off" :aria-label="$t('settings.environnment_type')" v-model="settings['Environment']" class="form-control pr-5 col-7" :disabled="!doesEdit">
                        <option v-for="(env, index) in environnments" :key="env.name + '-' + index" :value="env.value">{{ $t('settings.' + env.name) }}</option>
                      </select>
                  </form-write-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="$t('settings.archive_purge_history')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.global_audittrail_archive_freq') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="global_audittrail_archive_freq"
                        v-model="globalAuditTrailArchiveFrequenceYear" :disabled="!doesEdit" :key="'globalAuditTrailArchFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.global_audittrail_archive_freq_year')"
                        :inputAriaLabel="$t('settings.global_audittrail_archive_freq_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="globalAuditTrailArchiveFrequenceMonth" :disabled="!doesEdit" :key="'globalAuditTrailArchFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.global_audittrail_archive_freq_month')"
                        :inputAriaLabel="$t('settings.global_audittrail_archive_freq_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="globalAuditTrailArchiveFrequenceDay" :disabled="!doesEdit" :key="'globalAuditTrailArchFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.global_audittrail_archive_freq_day')"
                        :inputAriaLabel="$t('settings.global_audittrail_archive_freq_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.global_audittrail_archive_delay') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="global_audittrail_archive_delay"
                        v-model="globalAuditTrailArchiveDelayYear" :disabled="!doesEdit" :key="'globalAuditTrailArchDelY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.global_audittrail_archive_delay_year')"
                        :inputAriaLabel="$t('settings.global_audittrail_archive_delay_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="globalAuditTrailArchiveDelayMonth" :disabled="!doesEdit" :key="'globalAuditTrailArchDelM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :inputLabel="$t('common.month')"
                        :inputAriaLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="globalAuditTrailArchiveDelayDay" :disabled="!doesEdit" :key="'globalAuditTrailArchDelD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.global_audittrail_archive_delay_day')"
                        :inputAriaLabel="$t('settings.global_audittrail_archive_delay_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="globalAuditTrailLastArchive"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.global_audittrail_last_archive')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.global_audittrail_purge_freq') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="global_audittrail_purge_freq"
                        v-model="globalAuditTrailPurgeFrequenceYear" :disabled="!doesEdit" :key="'globalAuditTrailPurgFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.global_audittrail_purge_freq_year')"
                        :inputAriaLabel="$t('settings.global_audittrail_purge_freq_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="globalAuditTrailPurgeFrequenceMonth" :disabled="!doesEdit" :key="'globalAuditTrailPurgFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.global_audittrail_purge_freq_month')"
                        :inputAriaLabel="$t('settings.global_audittrail_purge_freq_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="globalAuditTrailPurgeFrequenceDay" :disabled="!doesEdit" :key="'globalAuditTrailPurgFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.global_audittrail_purge_freq_day')"
                        :inputAriaLabel="$t('settings.global_audittrail_purge_freq_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.global_audittrail_purge_delay') }}</span>
                    <div  class="d-flex col-7">
                      <form-write-group-label-input
                          id="global_audittrail_purge_delay"
                        v-model="globalAuditTrailPurgeDelayYear" :disabled="!doesEdit" :key="'globalAuditTrailPurDelqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.global_audittrail_purge_delay_year')"
                        :inputAriaLabel="$t('settings.global_audittrail_purge_delay_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="globalAuditTrailPurgeDelayMonth" :disabled="!doesEdit" :key="'globalAuditTrailPurDelqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.global_audittrail_purge_delay_month')"
                        :inputAriaLabel="$t('settings.global_audittrail_purge_delay_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="globalAuditTrailPurgeDelayDay" :disabled="!doesEdit" :key="'globalAuditTrailPurDelqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.global_audittrail_purge_delay_day')"
                        :inputAriaLabel="$t('settings.global_audittrail_purge_delay_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="globalAuditTrailLastPurge"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.global_audittrail_last_purge')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
          </b-tab>
          <!--EBA SETTINGS-->
          <b-tab>
            <form-accordion :title="$t('settings.general_sttngs')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-write-group-label-input
                    v-model="settings.RTPSPIdentifier" :disabled="!doesEdit"
                    inputType="text"
                    autocomplete="off"
                    :inputLabel="$t('administration.rtp_identifier_srtp')"
                    horizontal>
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-write-group-label-input
                    v-model="settings['SRTP-RTPSPMaxAmount']" :disabled="!doesEdit" :key="'srtpMaxAmount'+resetInput"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="number"
                    :inputLabel="$t('settings.max_amnt_srtp')"
                    horizontal
                    @input="controlMaxAmountSRTP"
                    @blur="changeMaxAmountSRTP">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-write-group-label-input
                    v-model="settings.RTPSPTimeBeforeExpiration" :disabled="!doesEdit" :key="'SRTPExp'+resetInput"
                    :maxLength="21"
                    inputType="number"
                    :inputLabel="$t('administration.rtp_time_before_expiration')"
                    horizontal
                    @input="controlTimeBeforeExpSRTP"
                    @blur="changeTimeBeforeExpSRTP">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="$t('settings.archive_purge_messages')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.srtp_archive_freq') }}</span>
                    <div  class="d-flex col-7">
                      <form-write-group-label-input
                          id="srtp_archive_freq"
                        v-model="srtpArchiveFrequenceYear" :disabled="!doesEdit" :key="'srtpArchFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_archive_freq_year')"
                        :inputAriaLabel="$t('settings.srtp_archive_freq_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpArchiveFrequenceMonth" :disabled="!doesEdit" :key="'srtpArchFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_archive_freq_month')"
                        :inputAriaLabel="$t('settings.srtp_archive_freq_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpArchiveFrequenceDay" :disabled="!doesEdit" :key="'srtpArchFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_archive_freq_day')"
                        :inputAriaLabel="$t('settings.srtp_archive_freq_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.srtp_archive_delay') }}</span>
                    <div  class="d-flex col-7">
                      <form-write-group-label-input
                          id="srtp_archive_delay"
                        v-model="srtpArchiveDelayYear" :disabled="!doesEdit" :key="'srtpArchDelY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_archive_delay_year')"
                        :inputAriaLabel="$t('settings.srtp_archive_delay_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpArchiveDelayMonth" :disabled="!doesEdit" :key="'srtpArchDelM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_archive_delay_month')"
                        :inputAriaLabel="$t('settings.srtp_archive_delay_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpArchiveDelayDay" :disabled="!doesEdit" :key="'srtpArchDelD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_archive_delay_day')"
                        :inputAriaLabel="$t('settings.srtp_archive_delay_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="srtpLastArchive"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.srtp_last_archive')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.srtp_purge_freq') }}</span>
                    <div  class="d-flex col-7">
                      <form-write-group-label-input
                          id="srtp_purge_freq"
                        v-model="srtpPurgeFrequenceYear" :disabled="!doesEdit" :key="'srtpPurgFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_purge_freq_year')"
                        :inputAriaLabel="$t('settings.srtp_purge_freq_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpPurgeFrequenceMonth" :disabled="!doesEdit" :key="'srtpPurgFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_purge_freq_month')"
                        :inputAriaLabel="$t('settings.srtp_purge_freq_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpPurgeFrequenceDay" :disabled="!doesEdit" :key="'srtpPurgFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_purge_freq_day')"
                        :inputAriaLabel="$t('settings.srtp_purge_freq_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.srtp_purge_delay') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="srtp_purge_delay"
                        v-model="srtpPurgeDelayYear" :disabled="!doesEdit" :key="'srtpPurDelqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_purge_delay_year')"
                        :inputAriaLabel="$t('settings.srtp_purge_delay_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpPurgeDelayMonth" :disabled="!doesEdit" :key="'srtpPurDelqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_purge_delay_month')"
                        :inputAriaLabel="$t('settings.srtp_purge_delay_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpPurgeDelayDay" :disabled="!doesEdit" :key="'srtpPurDelqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_purge_delay_day')"
                        :inputAriaLabel="$t('settings.srtp_purge_delay_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="srtpLastPurge"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.srtp_last_purge')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="$t('settings.archive_purge_history')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.srtp_audittrail_archive_freq') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="srtp_audittrail_archive_freq"
                        v-model="srtpAuditTrailArchiveFrequenceYear" :disabled="!doesEdit" :key="'srtpAuditTrailArchFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_audittrail_archive_freq_year')"
                        :inputAriaLabel="$t('settings.srtp_audittrail_archive_freq_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpAuditTrailArchiveFrequenceMonth" :disabled="!doesEdit" :key="'srtpAuditTrailArchFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_audittrail_archive_freq_month')"
                        :inputAriaLabel="$t('settings.srtp_audittrail_archive_freq_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpAuditTrailArchiveFrequenceDay" :disabled="!doesEdit" :key="'srtpAuditTrailArchFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_audittrail_archive_freq_day')"
                        :inputAriaLabel="$t('settings.srtp_audittrail_archive_freq_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.srtp_audittrail_archive_delay') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="srtp_audittrail_archive_delay"
                        v-model="srtpAuditTrailArchiveDelayYear" :disabled="!doesEdit" :key="'srtpAuditTrailArchDelY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_audittrail_archive_delay_year')"
                        :inputAriaLabel="$t('settings.srtp_audittrail_archive_delay_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpAuditTrailArchiveDelayMonth" :disabled="!doesEdit" :key="'srtpAuditTrailArchDelM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_audittrail_archive_delay_month')"
                        :inputAriaLabel="$t('settings.srtp_audittrail_archive_delay_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpAuditTrailArchiveDelayDay" :disabled="!doesEdit" :key="'srtpAuditTrailArchDelD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_audittrail_archive_delay_day')"
                        :inputAriaLabel="$t('settings.srtp_audittrail_archive_delay_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="srtpAuditTrailLastArchive"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.srtp_audittrail_last_archive')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.srtp_audittrail_purge_freq') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="srtp_audittrail_purge_freq"
                        v-model="srtpAuditTrailPurgeFrequenceYear" :disabled="!doesEdit" :key="'srtpAuditTrailPurgFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_audittrail_purge_freq_year')"
                        :inputAriaLabel="$t('settings.srtp_audittrail_purge_freq_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpAuditTrailPurgeFrequenceMonth" :disabled="!doesEdit" :key="'srtpAuditTrailPurgFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_audittrail_purge_freq_month')"
                        :inputAriaLabel="$t('settings.srtp_audittrail_purge_freq_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpAuditTrailPurgeFrequenceDay" :disabled="!doesEdit" :key="'srtpAuditTrailPurgFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_audittrail_purge_freq_day')"
                        :inputAriaLabel="$t('settings.srtp_audittrail_purge_freq_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.srtp_audittrail_purge_delay') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="srtp_audittrail_purge_delay"
                        v-model="srtpAuditTrailPurgeDelayYear" :disabled="!doesEdit" :key="'srtpAuditTrailPurDelqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_audittrail_purge_delay_year')"
                        :inputAriaLabel="$t('settings.srtp_audittrail_purge_delay_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpAuditTrailPurgeDelayMonth" :disabled="!doesEdit" :key="'srtpAuditTrailPurDelqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_audittrail_purge_delay_month')"
                        :inputAriaLabel="$t('settings.srtp_audittrail_purge_delay_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="srtpAuditTrailPurgeDelayDay" :disabled="!doesEdit" :key="'srtpAuditTrailPurDelqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.srtp_audittrail_purge_delay_day')"
                        :inputAriaLabel="$t('settings.srtp_audittrail_purge_delay_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="srtpAuditTrailLastPurge"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.srtp_audittrail_last_purge')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
          </b-tab>
          <!--GIRO SETTINGS-->
          <b-tab>
            <form-accordion :title="$t('settings.general_sttngs')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-write-group-label-input
                    v-model="settings['HRTP-Identifier']" :disabled="!doesEdit"
                    inputType="text"
                    autocomplete="off"
                    :inputAriaLabel="$t('administration.hrtp_identifier')"
                    :inputLabel="$t('administration.hrtp_identifier')"
                    horizontal>
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-write-group-label-input
                    v-model="settings['HRTP-RTPSPMaxAmount']" :disabled="!doesEdit" :key="'hrtpMaxAmount'+resetInput"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="number"
                    :inputLabel="$t('settings.max_amnt_hrtp')"
                    :inputAriaLabel="$t('settings.max_amnt_hrtp')"
                    horizontal
                    @input="controlMaxAmountHRTP"
                    @blur="changeMaxAmountHRTP">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-write-group-label-input
                    v-model="settings['HRTP-ValidityPeriod']" :disabled="!doesEdit" :key="'hrtpExp'+resetInput"
                    :maxLength="21"
                    inputType="number"
                    :inputLabel="$t('administration.rtp_h_validity_period')"
                    :inputAriaLabel="$t('administration.rtp_h_validity_period')"
                    horizontal
                    @input="controlTimeBeforeExpHRTP"
                    @blur="changeVldityPeriodHRTP">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="$t('settings.archive_purge_messages')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.hrtp_archive_freq') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="hrtp_archive_freq"
                        v-model="hrtpArchiveFrequenceYear" :disabled="!doesEdit" :key="'hrtpArchFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_archive_freq_year')"
                        :inputAriaLabel="$t('settings.hrtp_archive_freq_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpArchiveFrequenceMonth" :disabled="!doesEdit" :key="'hrtpArchFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_archive_freq_month')"
                        :inputAriaLabel="$t('settings.hrtp_archive_freq_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpArchiveFrequenceDay" :disabled="!doesEdit" :key="'hrtpArchFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_archive_freq_day')"
                        :inputAriaLabel="$t('settings.hrtp_archive_freq_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.hrtp_archive_delay') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="hrtp_archive_delay"
                        v-model="hrtpArchiveDelayYear" :disabled="!doesEdit" :key="'hrtpArchDelY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_archive_delay_year')"
                        :inputAriaLabel="$t('settings.hrtp_archive_delay_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpArchiveDelayMonth" :disabled="!doesEdit" :key="'hrtpArchDelM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_archive_delay_month')"
                        :inputAriaLabel="$t('settings.hrtp_archive_delay_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpArchiveDelayDay" :disabled="!doesEdit" :key="'hrtpArchDelD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_archive_delay_day')"
                        :inputAriaLabel="$t('settings.hrtp_archive_delay_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="hrtpLastArchive"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.hrtp_last_archive')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.hrtp_purge_freq') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="hrtp_purge_freq"
                        v-model="hrtpPurgeFrequenceYear" :disabled="!doesEdit" :key="'hrtpPurgFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_purge_freq_year')"
                        :inputAriaLabel="$t('settings.hrtp_purge_freq_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpPurgeFrequenceMonth" :disabled="!doesEdit" :key="'hrtpPurgFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_purge_freq_month')"
                        :inputAriaLabel="$t('settings.hrtp_purge_freq_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpPurgeFrequenceDay" :disabled="!doesEdit" :key="'hrtpPurgFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_purge_freq_day')"
                        :inputAriaLabel="$t('settings.hrtp_purge_freq_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.hrtp_purge_delay') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="hrtp_purge_delay"
                        v-model="hrtpPurgeDelayYear" :disabled="!doesEdit" :key="'hrtpPurgDelY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_purge_delay_year')"
                        :inputAriaLabel="$t('settings.hrtp_purge_delay_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpPurgeDelayMonth" :disabled="!doesEdit" :key="'hrtpPurgDelM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_purge_delay_month')"
                        :inputAriaLabel="$t('settings.hrtp_purge_delay_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpPurgeDelayDay" :disabled="!doesEdit" :key="'hrtpPurgDelD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_purge_delay_day')"
                        :inputAriaLabel="$t('settings.hrtp_purge_delay_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="hrtpLastPurge"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.hrtp_last_purge')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="$t('settings.archive_purge_history')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.hrtp_audittrail_archive_freq') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="hrtp_audittrail_archive_freq"
                        v-model="hrtpAuditTrailArchiveFrequenceYear" :disabled="!doesEdit" :key="'hrtpAuditTrailArchFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_audittrail_archive_freq_year')"
                        :inputAriaLabel="$t('settings.hrtp_audittrail_archive_freq_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpAuditTrailArchiveFrequenceMonth" :disabled="!doesEdit" :key="'hrtpAuditTrailArchFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_audittrail_archive_freq_month')"
                        :inputAriaLabel="$t('settings.hrtp_audittrail_archive_freq_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpAuditTrailArchiveFrequenceDay" :disabled="!doesEdit" :key="'hrtpAuditTrailArchFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_audittrail_archive_freq_day')"
                        :inputAriaLabel="$t('settings.hrtp_audittrail_archive_freq_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.hrtp_audittrail_archive_delay') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="hrtp_audittrail_archive_delay"
                        v-model="hrtpAuditTrailArchiveDelayYear" :disabled="!doesEdit" :key="'hrtpArchDelY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_audittrail_archive_delay_year')"
                        :inputAriaLabel="$t('settings.hrtp_audittrail_archive_delay_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpAuditTrailArchiveDelayMonth" :disabled="!doesEdit" :key="'hrtpArchDelM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_audittrail_archive_delay_month')"
                        :inputAriaLabel="$t('settings.hrtp_audittrail_archive_delay_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpAuditTrailArchiveDelayDay" :disabled="!doesEdit" :key="'hrtpArchDelD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_audittrail_archive_delay_day')"
                        :inputAriaLabel="$t('settings.hrtp_audittrail_archive_delay_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="hrtpAuditTrailLastArchive"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.hrtp_audittrail_last_archive')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.hrtp_audittrail_purge_freq') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="hrtp_audittrail_purge_freq"
                        v-model="hrtpAuditTrailPurgeFrequenceYear" :disabled="!doesEdit" :key="'hrtpAuditTrailPurgFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_audittrail_purge_freq_year')"
                        :inputAriaLabel="$t('settings.hrtp_audittrail_purge_freq_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpAuditTrailPurgeFrequenceMonth" :disabled="!doesEdit" :key="'hrtpAuditTrailPurgFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_audittrail_purge_freq_month')"
                        :inputAriaLabel="$t('settings.hrtp_audittrail_purge_freq_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpAuditTrailPurgeFrequenceDay" :disabled="!doesEdit" :key="'hrtpAuditTrailPurgFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_audittrail_purge_freq_day')"
                        :inputAriaLabel="$t('settings.hrtp_audittrail_purge_freq_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <label for="hrtp_audittrail_purge_delay" class="col-5 d-flex align-items-end">{{ $t('settings.hrtp_audittrail_purge_delay') }}</label>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="hrtp_audittrail_purge_delay"
                        v-model="hrtpAuditTrailPurgeDelayYear" :disabled="!doesEdit" :key="'hrtpAuditTrailPurgDelY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_audittrail_purge_delay_year')"
                        :inputAriaLabel="$t('settings.hrtp_audittrail_purge_delay_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpAuditTrailPurgeDelayMonth" :disabled="!doesEdit" :key="'hrtpAuditTrailPurgDelM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_audittrail_purge_delay_month')"
                        :inputAriaLabel="$t('settings.hrtp_audittrail_purge_delay_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="hrtpAuditTrailPurgeDelayDay" :disabled="!doesEdit" :key="'hrtpAuditTrailPurgDelD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.hrtp_audittrail_purge_delay_day')"
                        :inputAriaLabel="$t('settings.hrtp_audittrail_purge_delay_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="hrtpAuditTrailLastPurge"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.hrtp_audittrail_last_purge')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
          </b-tab>
          <!-- PSD2 Settings -->
          <b-tab>
            <b-row>
              <b-col cols="12" lg="10" offset="1" class="mb-3">
                <form-write-group-label-input
                  v-model="settings['PSD2-Token.io-JWT-Expiration']" :disabled="!doesEdit" :key="'psd2tokeniojwtexpiration'+resetInput"
                  inputType="text"
                  autocomplete="off"
                  :inputLabel="$t('settings.tokenio_jwt_expiration')"
                  horizontal>
                </form-write-group-label-input>
              </b-col>
              <b-col cols="12" lg="10" offset="1" class="mb-3">
                <form-write-group-label-input
                  v-model="settings['PSD2-Worldline-Requester']" :disabled="!doesEdit" :key="'psd2worldlinerequester'+resetInput"
                  inputType="text"
                  autocomplete="off"
                  :inputLabel="$t('settings.worldline_requester')"
                  horizontal>
                </form-write-group-label-input>
              </b-col>
              <b-col cols="12" lg="10" offset="1" class="mb-3">
                <form-write-group-label-input
                  v-model="settings['PSD2-Worldline-Stream-Email']" :disabled="!doesEdit" :key="'psd2worldlinestreamemail'+resetInput"
                  inputType="text"
                  autocomplete="off"
                  :inputLabel="$t('settings.worldline_stream_email')"
                  horizontal>
                </form-write-group-label-input>
              </b-col>
              <b-col cols="12" lg="10" offset="1" class="mb-3">
                <form-write-group-label-input
                  v-model="settings['PSD2-Worldline-Stream-SMS']" :disabled="!doesEdit" :key="'psd2worldlinestreamsms'+resetInput"
                  inputType="text"
                  autocomplete="off"
                  :inputLabel="$t('settings.worldline_stream_sms')"
                  horizontal>
                </form-write-group-label-input>
              </b-col>
            </b-row>
            <form-accordion :title="$t('settings.archive_purge_messages')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.psd2_archive_freq') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="psd2_archive_freq"
                        v-model="psd2ArchiveFrequenceYear" :disabled="!doesEdit" :key="'psd2ArchFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_archive_freq_year')"
                        :inputAriaLabel="$t('settings.psd2_archive_freq_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="psd2ArchiveFrequenceMonth" :disabled="!doesEdit" :key="'psd2ArchFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_archive_freq_month')"
                        :inputAriaLabel="$t('settings.psd2_archive_freq_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="psd2ArchiveFrequenceDay" :disabled="!doesEdit" :key="'psd2ArchFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_archive_freq_day')"
                        :inputAriaLabel="$t('settings.psd2_archive_freq_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.psd2_archive_delay') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="psd2_archive_delay"
                        v-model="psd2ArchiveDelayYear" :disabled="!doesEdit" :key="'psd2ArchDelY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_archive_delay_year')"
                        :inputAriaLabel="$t('settings.psd2_archive_delay_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="psd2ArchiveDelayMonth" :disabled="!doesEdit" :key="'psd2ArchDelM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_archive_delay_month')"
                        :inputAriaLabel="$t('settings.psd2_archive_delay_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="psd2ArchiveDelayDay" :disabled="!doesEdit" :key="'psd2ArchDelD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_archive_delay_day')"
                        :inputAriaLabel="$t('settings.psd2_archive_delay_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="psd2LastArchive"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.psd2_last_archive')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.psd2_purge_freq') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="psd2_purge_freq"
                        v-model="psd2PurgeFrequenceYear" :disabled="!doesEdit" :key="'psd2PurgFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_purge_freq_year')"
                        :inputAriaLabel="$t('settings.psd2_purge_freq_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="psd2PurgeFrequenceMonth" :disabled="!doesEdit" :key="'psd2PurgFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_purge_freq_month')"
                        :inputAriaLabel="$t('settings.psd2_purge_freq_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="psd2PurgeFrequenceDay" :disabled="!doesEdit" :key="'psd2PurgFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_purge_freq_day')"
                        :inputAriaLabel="$t('settings.psd2_purge_freq_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.psd2_purge_delay') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="psd2_purge_delay"
                        v-model="psd2PurgeDelayYear" :disabled="!doesEdit" :key="'psd2PurgDelY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_purge_delay_year')"
                        :inputAriaLabel="$t('settings.psd2_purge_delay_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="psd2PurgeDelayMonth" :disabled="!doesEdit" :key="'psd2PurgDelM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_purge_delay_month')"
                        :inputAriaLabel="$t('settings.psd2_purge_delay_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="psd2PurgeDelayDay" :disabled="!doesEdit" :key="'psd2PurgDelD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_purge_delay_day')"
                        :inputAriaLabel="$t('settings.psd2_purge_delay_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="psd2LastPurge"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.psd2_last_purge')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="$t('settings.archive_purge_history')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <label for="psd2_audittrail_archive_freq" class="col-5 d-flex align-items-end">{{ $t('settings.psd2_audittrail_archive_freq') }}</label>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="psd2_audittrail_archive_freq"
                        v-model="psd2AuditTrailArchiveFrequenceYear" :disabled="!doesEdit" :key="'psd2ArchFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_audittrail_archive_freq_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="psd2AuditTrailArchiveFrequenceMonth" :disabled="!doesEdit" :key="'psd2ArchFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_audittrail_archive_freq_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="psd2AuditTrailArchiveFrequenceDay" :disabled="!doesEdit" :key="'psd2ArchFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_audittrail_archive_freq_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.psd2_audittrail_archive_delay') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="psd2_audittrail_archive_delay_year"
                        v-model="psd2AuditTrailArchiveDelayYear" :disabled="!doesEdit" :key="'psd2ArchDelY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_audittrail_archive_delay_year')"
                        :inputAriaLabel="$t('settings.psd2_audittrail_archive_delay_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                          id="psd2_audittrail_archive_delay_month"
                        v-model="psd2AuditTrailArchiveDelayMonth" :disabled="!doesEdit" :key="'psd2ArchDelM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_audittrail_archive_delay_month')"
                        :inputAriaLabel="$t('settings.psd2_audittrail_archive_delay_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                          id="psd2_audittrail_archive_delay_day"
                        v-model="psd2AuditTrailArchiveDelayDay" :disabled="!doesEdit" :key="'psd2ArchDelD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_audittrail_archive_delay_day')"
                        :inputAriaLabel="$t('settings.psd2_audittrail_archive_delay_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="psd2AuditTrailLastArchive"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.psd2_audittrail_last_archive')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.psd2_audittrail_purge_freq') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="psd2_audittrail_purge_freq_year"
                        v-model="psd2AuditTrailPurgeFrequenceYear" :disabled="!doesEdit" :key="'psd2PurgFrqY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_audittrail_purge_freq_year')"
                        :inputAriaLabel="$t('settings.psd2_audittrail_archive_freq_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                          id="psd2_audittrail_purge_freq_month"
                        v-model="psd2AuditTrailPurgeFrequenceMonth" :disabled="!doesEdit" :key="'psd2PurgFrqM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_audittrail_purge_freq_month')"
                        :inputAriaLabel="$t('settings.psd2_audittrail_archive_freq_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                          id="psd2_audittrail_purge_freq_day"
                        v-model="psd2AuditTrailPurgeFrequenceDay" :disabled="!doesEdit" :key="'psd2PurgFrqD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_audittrail_purge_freq_day')"
                        :inputAriaLabel="$t('settings.psd2_audittrail_archive_freq_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <div class="justify-content-around d-flex justify-content-between align-items-bottom">
                    <span class="col-5 d-flex align-items-end">{{ $t('settings.psd2_audittrail_purge_delay') }}</span>
                    <div class="d-flex col-7">
                      <form-write-group-label-input
                          id="psd2_audittrail_purge_delay"
                        v-model="psd2AuditTrailPurgeDelayYear" :disabled="!doesEdit" :key="'psd2PurgDelY'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_audittrail_purge_delay_year')"
                        :inputAriaLabel="$t('settings.psd2_audittrail_purge_delay_year')"
                        :inputLabel="$t('common.year')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="psd2AuditTrailPurgeDelayMonth" :disabled="!doesEdit" :key="'psd2PurgDelM'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_audittrail_purge_delay_month')"
                        :inputAriaLabel="$t('settings.psd2_audittrail_purge_delay_month')"
                        :inputLabel="$t('common.month')">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        v-model="psd2AuditTrailPurgeDelayDay" :disabled="!doesEdit" :key="'psd2PurgDelD'+resetInput"
                        :maxLength="21"
                        class="justify-content-around"
                        inputType="number"
                        :labelContext="$t('settings.psd2_audittrail_purge_delay_day')"
                        :inputAriaLabel="$t('settings.psd2_audittrail_purge_delay_day')"
                        :inputLabel="$t('common.day')">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="10" offset="1" class="mb-3">
                  <form-read-group-label-input
                    :inputValue="psd2AuditTrailLastPurge"
                    :maxLength="21"
                    class="justify-content-around"
                    inputType="text"
                    :inputLabel="$t('settings.psd2_audittrail_last_purge')"
                    horizontal
                    >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
          </b-tab>
        </b-tabs>
      </div>
      <div class="col-md-10 offset-md-1" v-if="hasRight('application_global_rtp_settings_editer')">
        <b-row class="justify-content-end no-gutters" v-if="!doesEdit">
          <b-button @click="editSettings" variant="primary">
            <span>{{ $t("administration.edit") }}</span>
          </b-button>
        </b-row>
        <b-row v-else class="justify-content-end no-gutters">
          <div>
            <b-button @click="resetSettings" variant="primary">
              <span>{{ $t("common.cncl") }}</span>
            </b-button>
          </div>
          <div class="pl-3">
            <b-button @click="updateSettings(settings)" variant="primary">
              <span>{{ $t("common.update") }}</span>
            </b-button>
          </div>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>
<script>
import PageOutline from "@/components/common/PageOutline.vue"
import FormAccordion from "@/components/common/FormAccordion.vue"
import Spinner from "@/components/common/spinner.vue"
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import formReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue"
import { errorMessageAlert } from '@/helpers/alert'
import { loadPage } from '@/helpers/routing'

export default {
  name: "RTPSettings",
  components: {
    "page-outline": PageOutline,
    "form-accordion": FormAccordion,
    spinner: Spinner,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "form-read-group-label-input": formReadGroupLabelInput,
  },
  data () {
    return {
      activateSpinner: false,
      comaCount: 0,
      doesEdit: false,
      environnments: {},
      originalSettings: {},
      resetInput: false,
      settings: {
        'RTPMaxLinesExport': '',
        'Environment': '',
        RTPSPIdentifier: '',
        RTPSPTimeBeforeExpiration: '',
        'SRTP-API-AccountValidation': '',
        'SRTP-RTPSPMaxAmount': '',
        'HRTP-API-AccountValidation': '',
        'HRTP-RTPSPMaxAmount': '',
        'HRTP-ValidityPeriod': '',
        'Global-AuditTrail-PurgeFrequence': '',
        'SRTP-PurgeFrequence': '',
        'SRTP-AuditTrail-PurgeFrequence': '',
        'HRTP-PurgeFrequence': '',
        'HRTP-AuditTrail-PurgeFrequence': '',
        'PSD2-PurgeFrequence': '',
        'PSD2-AuditTrail-PurgeFrequence': '',
        'Global-AuditTrail-PurgeDelay': '',
        'SRTP-PurgeDelay': '',
        'SRTP-AuditTrail-PurgeDelay': '',
        'HRTP-PurgeDelay': '',
        'HRTP-AuditTrail-PurgeDelay': '',
        'PSD2-PurgeDelay': '',
        'PSD2-AuditTrail-PurgeDelay': '',
        'Global-AuditTrail-ArchiveFrequence': '',
        'SRTP-ArchiveFrequence': '',
        'SRTP-AuditTrail-ArchiveFrequence': '',
        'HRTP-ArchiveFrequence': '',
        'HRTP-AuditTrail-ArchiveFrequence': '',
        'PSD2-ArchiveFrequence': '',
        'PSD2-AuditTrail-ArchiveFrequence': '',
        'Global-AuditTrail-ArchiveDelay': '',
        'SRTP-ArchiveDelay': '',
        'SRTP-AuditTrail-ArchiveDelay': '',
        'HRTP-ArchiveDelay': '',
        'HRTP-AuditTrail-ArchiveDelay': '',
        'PSD2-ArchiveDelay': '',
        'PSD2-AuditTrail-ArchiveDelay': '',
        'PSD2-Worldline-Requester': '',
        'PSD2-Worldline-Stream-Email': '',
        'PSD2-Worldline-Stream-SMS': '',
        'Global-AuditTrail-LastPurge': '',
        'SRTP-AuditTrail-LastPurge': '',
        SRTP_LastPurge: '',
        'HRTP-AuditTrail-LastPurge': '',
        HRTP_LastPurge: '',
        'PSD2-AuditTrail-LastPurge': '',
        PSD2_LastPurge: '',
        'Global-AuditTrail-LastArchive': '',
        'SRTP-AuditTrail-LastArchive': '',
        SRTP_LastArchive: '',
        'HRTP-AuditTrail-LastArchive': '',
        HRTP_LastArchive: '',
        'PSD2-AuditTrail-LastArchive': '',
        PSD2_LastArchive: '',
      },
      tabName: 0
    }
  },
  computed: {
    canSeeSRTP () {
      return true
      // if (this.$engine.rights.rightIs('super_admin', true)) {
      //   return true
      // } else if (this.$engine.user.getUserNorm()) {
      //   return this.$engine.user.getUserNorm() === '1' && this.$engine.rights.rightIs('rtp_norm_srtp', true)
      // } else {
      //   return this.$engine.rights.rightIs('rtp_norm_srtp', true)
      // }
    },
    canSeeHRTP () {
      return true
      // if (this.$engine.rights.rightIs('super_admin', true)) {
      //   return true
      // } else if (this.$engine.user.getUserNorm()) {
      //   return this.$engine.user.getUserNorm() === '2' && this.$engine.rights.rightIs('rtp_norm_hrtp', true)
      // } else {
      //   return this.$engine.rights.rightIs('rtp_norm_hrtp', true)
      // }
    },
    canSeePSD2 () {
      return true
      // if (this.$engine.rights.rightIs('super_admin', true)) {
      //   return true
      // } else if (this.$engine.user.getUserNorm()) {
      //   return this.$engine.user.getUserNorm() === '3' && this.$engine.rights.rightIs('rtp_norm_psd2', true)
      // } else {
      //   return this.$engine.rights.rightIs('rtp_norm_psd2', true)
      // }
    },
    globalAuditTrailArchiveDelayYear : {
      get () {
        return this.settings['Global-AuditTrail-ArchiveDelay'] ? this.settings['Global-AuditTrail-ArchiveDelay'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('Global-AuditTrail-ArchiveDelay', 0, value)
      }
    },
    globalAuditTrailArchiveDelayMonth : {
      get () {
        return this.settings['Global-AuditTrail-ArchiveDelay'] ? this.settings['Global-AuditTrail-ArchiveDelay'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('Global-AuditTrail-ArchiveDelay', 1, value)
      }
    },
    globalAuditTrailArchiveDelayDay : {
      get () {
        return this.settings['Global-AuditTrail-ArchiveDelay'] ? this.settings['Global-AuditTrail-ArchiveDelay'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('Global-AuditTrail-ArchiveDelay', 2, value)
      }
    },
    globalAuditTrailArchiveFrequenceYear : {
      get () {
        return this.settings['Global-AuditTrail-ArchiveFrequence'] ? this.settings['Global-AuditTrail-ArchiveFrequence'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('Global-AuditTrail-ArchiveFrequence', 0, value)
      }
    },
    globalAuditTrailArchiveFrequenceMonth : {
      get () {
        return this.settings['Global-AuditTrail-ArchiveFrequence'] ? this.settings['Global-AuditTrail-ArchiveFrequence'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('Global-AuditTrail-ArchiveFrequence', 1, value)
      }
    },
    globalAuditTrailArchiveFrequenceDay : {
      get () {
        return this.settings['Global-AuditTrail-ArchiveFrequence'] ? this.settings['Global-AuditTrail-ArchiveFrequence'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('Global-AuditTrail-ArchiveFrequence', 2, value)
      }
    },
    globalAuditTrailLastArchive (){
      return this.$options.filters.formatDateTime(this.settings['Global-AuditTrail-LastArchive'])
    },
    globalAuditTrailLastPurge (){
      return this.$options.filters.formatDateTime(this.settings['Global-AuditTrail-LastPurge'])
    },
    globalAuditTrailPurgeDelayYear : {
      get () {
        return this.settings['Global-AuditTrail-PurgeDelay'] ? this.settings['Global-AuditTrail-PurgeDelay'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('Global-AuditTrail-PurgeDelay', 0, value)
      }
    },
    globalAuditTrailPurgeDelayMonth : {
      get () {
        return this.settings['Global-AuditTrail-PurgeDelay'] ? this.settings['Global-AuditTrail-PurgeDelay'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('Global-AuditTrail-PurgeDelay', 1, value)
      }
    },
    globalAuditTrailPurgeDelayDay : {
      get () {
        return this.settings['Global-AuditTrail-PurgeDelay'] ? this.settings['Global-AuditTrail-PurgeDelay'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('Global-AuditTrail-PurgeDelay', 2, value)
      }
    },
    globalAuditTrailPurgeFrequenceYear : {
      get () {
        return this.settings['Global-AuditTrail-PurgeFrequence'] ? this.settings['Global-AuditTrail-PurgeFrequence'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('Global-AuditTrail-PurgeFrequence', 0, value)
      }
    },
    globalAuditTrailPurgeFrequenceMonth : {
      get () {
        return this.settings['Global-AuditTrail-PurgeFrequence'] ? this.settings['Global-AuditTrail-PurgeFrequence'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('Global-AuditTrail-PurgeFrequence', 1, value)
      }
    },
    globalAuditTrailPurgeFrequenceDay : {
      get () {
        return this.settings['Global-AuditTrail-PurgeFrequence'] ? this.settings['Global-AuditTrail-PurgeFrequence'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('Global-AuditTrail-PurgeFrequence', 2, value)
      }
    },
    hrtpAuditTrailArchiveDelayYear : {
      get () {
        return this.settings['HRTP-AuditTrail-ArchiveDelay'] ? this.settings['HRTP-AuditTrail-ArchiveDelay'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-AuditTrail-ArchiveDelay', 0, value)
      }
    },
    hrtpAuditTrailArchiveDelayMonth : {
      get () {
        return this.settings['HRTP-AuditTrail-ArchiveDelay'] ? this.settings['HRTP-AuditTrail-ArchiveDelay'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-AuditTrail-ArchiveDelay', 1, value)
      }
    },
    hrtpAuditTrailArchiveDelayDay : {
      get () {
        return this.settings['HRTP-AuditTrail-ArchiveDelay'] ? this.settings['HRTP-AuditTrail-ArchiveDelay'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-AuditTrail-ArchiveDelay', 2, value)
      }
    },
    hrtpArchiveDelayYear : {
      get () {
        return this.settings['HRTP-ArchiveDelay'] ? this.settings['HRTP-ArchiveDelay'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-ArchiveDelay', 0, value)
      }
    },
    hrtpArchiveDelayMonth : {
      get () {
        return this.settings['HRTP-ArchiveDelay'] ? this.settings['HRTP-ArchiveDelay'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-ArchiveDelay', 1, value)
      }
    },
    hrtpArchiveDelayDay : {
      get () {
        return this.settings['HRTP-ArchiveDelay'] ? this.settings['HRTP-ArchiveDelay'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-ArchiveDelay', 2, value)
      }
    },
    hrtpAuditTrailArchiveFrequenceYear : {
      get () {
        return this.settings['HRTP-AuditTrail-ArchiveFrequence'] ? this.settings['HRTP-AuditTrail-ArchiveFrequence'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-AuditTrail-ArchiveFrequence', 0, value)
      }
    },
    hrtpAuditTrailArchiveFrequenceMonth : {
      get () {
        return this.settings['HRTP-AuditTrail-ArchiveFrequence'] ? this.settings['HRTP-AuditTrail-ArchiveFrequence'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-AuditTrail-ArchiveFrequence', 1, value)
      }
    },
    hrtpAuditTrailArchiveFrequenceDay : {
      get () {
        return this.settings['HRTP-AuditTrail-ArchiveFrequence'] ? this.settings['HRTP-AuditTrail-ArchiveFrequence'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-AuditTrail-ArchiveFrequence', 2, value)
      }
    },
    hrtpArchiveFrequenceYear : {
      get () {
        return this.settings['HRTP-ArchiveFrequence'] ? this.settings['HRTP-ArchiveFrequence'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-ArchiveFrequence', 0, value)
      }
    },
    hrtpArchiveFrequenceMonth : {
      get () {
        return this.settings['HRTP-ArchiveFrequence'] ? this.settings['HRTP-ArchiveFrequence'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-ArchiveFrequence', 1, value)
      }
    },
    hrtpArchiveFrequenceDay : {
      get () {
        return this.settings['HRTP-ArchiveFrequence'] ? this.settings['HRTP-ArchiveFrequence'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-ArchiveFrequence', 2, value)
      }
    },
    hrtpLastArchive (){
      return this.$options.filters.formatDateTime(this.settings.HRTP_LastArchive)
    },
    hrtpAuditTrailLastArchive (){
      return this.$options.filters.formatDateTime(this.settings['HRTP-AuditTrail-LastArchive'])
    },
    hrtpLastPurge (){
      return this.$options.filters.formatDateTime(this.settings.HRTP_LastPurge)
    },
    hrtpAuditTrailLastPurge (){
      return this.$options.filters.formatDateTime(this.settings['HRTP-AuditTrail-LastPurge'])
    },
    hrtpAuditTrailPurgeDelayYear : {
      get () {
        return this.settings['HRTP-AuditTrail-PurgeDelay'] ? this.settings['HRTP-AuditTrail-PurgeDelay'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-AuditTrail-PurgeDelay', 0, value)
      }
    },
    hrtpAuditTrailPurgeDelayMonth : {
      get () {
        return this.settings['HRTP-AuditTrail-PurgeDelay'] ? this.settings['HRTP-AuditTrail-PurgeDelay'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-AuditTrail-PurgeDelay', 1, value)
      }
    },
    hrtpAuditTrailPurgeDelayDay : {
      get () {
        return this.settings['HRTP-AuditTrail-PurgeDelay'] ? this.settings['HRTP-AuditTrail-PurgeDelay'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-AuditTrail-PurgeDelay', 2, value)
      }
    },
    hrtpPurgeDelayYear : {
      get () {
        return this.settings['HRTP-PurgeDelay'] ? this.settings['HRTP-PurgeDelay'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-PurgeDelay', 0, value)
      }
    },
    hrtpPurgeDelayMonth : {
      get () {
        return this.settings['HRTP-PurgeDelay'] ? this.settings['HRTP-PurgeDelay'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-PurgeDelay', 1, value)
      }
    },
    hrtpPurgeDelayDay : {
      get () {
        return this.settings['HRTP-PurgeDelay'] ? this.settings['HRTP-PurgeDelay'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-PurgeDelay', 2, value)
      }
    },
    hrtpAuditTrailPurgeFrequenceYear : {
      get () {
        return this.settings['HRTP-AuditTrail-PurgeFrequence'] ? this.settings['HRTP-AuditTrail-PurgeFrequence'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-AuditTrail-PurgeFrequence', 0, value)
      }
    },
    hrtpAuditTrailPurgeFrequenceMonth : {
      get () {
        return this.settings['HRTP-AuditTrail-PurgeFrequence'] ? this.settings['HRTP-AuditTrail-PurgeFrequence'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-AuditTrail-PurgeFrequence', 1, value)
      }
    },
    hrtpAuditTrailPurgeFrequenceDay : {
      get () {
        return this.settings['HRTP-AuditTrail-PurgeFrequence'] ? this.settings['HRTP-AuditTrail-PurgeFrequence'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-AuditTrail-PurgeFrequence', 2, value)
      }
    },
    hrtpPurgeFrequenceYear : {
      get () {
        return this.settings['HRTP-PurgeFrequence'] ? this.settings['HRTP-PurgeFrequence'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-PurgeFrequence', 0, value)
      }
    },
    hrtpPurgeFrequenceMonth : {
      get () {
        return this.settings['HRTP-PurgeFrequence'] ? this.settings['HRTP-PurgeFrequence'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-PurgeFrequence', 1, value)
      }
    },
    hrtpPurgeFrequenceDay : {
      get () {
        return this.settings['HRTP-PurgeFrequence'] ? this.settings['HRTP-PurgeFrequence'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('HRTP-PurgeFrequence', 2, value)
      }
    },
    psd2AuditTrailArchiveDelayYear : {
      get () {
        return this.settings['PSD2-AuditTrail-ArchiveDelay'] ? this.settings['PSD2-AuditTrail-ArchiveDelay'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-AuditTrail-ArchiveDelay', 0, value)
      }
    },
    psd2AuditTrailArchiveDelayMonth : {
      get () {
        return this.settings['PSD2-AuditTrail-ArchiveDelay'] ? this.settings['PSD2-AuditTrail-ArchiveDelay'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-AuditTrail-ArchiveDelay', 1, value)
      }
    },
    psd2AuditTrailArchiveDelayDay : {
      get () {
        return this.settings['PSD2-AuditTrail-ArchiveDelay'] ? this.settings['PSD2-AuditTrail-ArchiveDelay'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-AuditTrail-ArchiveDelay', 2, value)
      }
    },
    psd2ArchiveDelayYear : {
      get () {
        return this.settings['PSD2-ArchiveDelay'] ? this.settings['PSD2-ArchiveDelay'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-ArchiveDelay', 0, value)
      }
    },
    psd2ArchiveDelayMonth : {
      get () {
        return this.settings['PSD2-ArchiveDelay'] ? this.settings['PSD2-ArchiveDelay'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-ArchiveDelay', 1, value)
      }
    },
    psd2ArchiveDelayDay : {
      get () {
        return this.settings['PSD2-ArchiveDelay'] ? this.settings['PSD2-ArchiveDelay'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-ArchiveDelay', 2, value)
      }
    },
    psd2AuditTrailArchiveFrequenceYear : {
      get () {
        return this.settings['PSD2-AuditTrail-ArchiveFrequence'] ? this.settings['PSD2-AuditTrail-ArchiveFrequence'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-AuditTrail-ArchiveFrequence', 0, value)
      }
    },
    psd2AuditTrailArchiveFrequenceMonth : {
      get () {
        return this.settings['PSD2-AuditTrail-ArchiveFrequence'] ? this.settings['PSD2-AuditTrail-ArchiveFrequence'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-AuditTrail-ArchiveFrequence', 1, value)
      }
    },
    psd2AuditTrailArchiveFrequenceDay : {
      get () {
        return this.settings['PSD2-AuditTrail-ArchiveFrequence'] ? this.settings['PSD2-AuditTrail-ArchiveFrequence'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-AuditTrail-ArchiveFrequence', 2, value)
      }
    },
    psd2ArchiveFrequenceYear : {
      get () {
        return this.settings['PSD2-ArchiveFrequence'] ? this.settings['PSD2-ArchiveFrequence'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-ArchiveFrequence', 0, value)
      }
    },
    psd2ArchiveFrequenceMonth : {
      get () {
        return this.settings['PSD2-ArchiveFrequence'] ? this.settings['PSD2-ArchiveFrequence'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-ArchiveFrequence', 1, value)
      }
    },
    psd2ArchiveFrequenceDay : {
      get () {
        return this.settings['PSD2-ArchiveFrequence'] ? this.settings['PSD2-ArchiveFrequence'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-ArchiveFrequence', 2, value)
      }
    },
    psd2AuditTrailLastArchive (){
      return this.$options.filters.formatDateTime(this.settings['PSD2-AuditTrail-LastArchive'])
    },
    psd2LastArchive (){
      return this.$options.filters.formatDateTime(this.settings.PSD2_LastArchive)
    },
    psd2AuditTrailLastPurge (){
      return this.$options.filters.formatDateTime(this.settings['PSD2-AuditTrail-LastPurge'])
    },
    psd2LastPurge (){
      return this.$options.filters.formatDateTime(this.settings.PSD2_LastPurge)
    },
    psd2AuditTrailPurgeDelayYear : {
      get () {
        return this.settings['PSD2-AuditTrail-PurgeDelay'] ? this.settings['PSD2-AuditTrail-PurgeDelay'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-AuditTrail-PurgeDelay', 0, value)
      }
    },
    psd2AuditTrailPurgeDelayMonth : {
      get () {
        return this.settings['PSD2-AuditTrail-PurgeDelay'] ? this.settings['PSD2-AuditTrail-PurgeDelay'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-AuditTrail-PurgeDelay', 1, value)
      }
    },
    psd2AuditTrailPurgeDelayDay : {
      get () {
        return this.settings['PSD2-AuditTrail-PurgeDelay'] ? this.settings['PSD2-AuditTrail-PurgeDelay'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-AuditTrail-PurgeDelay', 2, value)
      }
    },
    psd2PurgeDelayYear : {
      get () {
        return this.settings['PSD2-PurgeDelay'] ? this.settings['PSD2-PurgeDelay'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-PurgeDelay', 0, value)
      }
    },
    psd2PurgeDelayMonth : {
      get () {
        return this.settings['PSD2-PurgeDelay'] ? this.settings['PSD2-PurgeDelay'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-PurgeDelay', 1, value)
      }
    },
    psd2PurgeDelayDay : {
      get () {
        return this.settings['PSD2-PurgeDelay'] ? this.settings['PSD2-PurgeDelay'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-PurgeDelay', 2, value)
      }
    },
    psd2AuditTrailPurgeFrequenceYear : {
      get () {
        return this.settings['PSD2-AuditTrail-PurgeFrequence'] ? this.settings['PSD2-AuditTrail-PurgeFrequence'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-AuditTrail-PurgeFrequence', 0, value)
      }
    },
    psd2AuditTrailPurgeFrequenceMonth : {
      get () {
        return this.settings['PSD2-AuditTrail-PurgeFrequence'] ? this.settings['PSD2-AuditTrail-PurgeFrequence'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-AuditTrail-PurgeFrequence', 1, value)
      }
    },
    psd2AuditTrailPurgeFrequenceDay : {
      get () {
        return this.settings['PSD2-AuditTrail-PurgeFrequence'] ? this.settings['PSD2-AuditTrail-PurgeFrequence'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-AuditTrail-PurgeFrequence', 2, value)
      }
    },
    psd2PurgeFrequenceYear : {
      get () {
        return this.settings['PSD2-PurgeFrequence'] ? this.settings['PSD2-PurgeFrequence'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-PurgeFrequence', 0, value)
      }
    },
    psd2PurgeFrequenceMonth : {
      get () {
        return this.settings['PSD2-PurgeFrequence'] ? this.settings['PSD2-PurgeFrequence'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-PurgeFrequence', 1, value)
      }
    },
    psd2PurgeFrequenceDay : {
      get () {
        return this.settings['PSD2-PurgeFrequence'] ? this.settings['PSD2-PurgeFrequence'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('PSD2-PurgeFrequence', 2, value)
      }
    },
    srtpAuditTrailArchiveDelayYear : {
      get () {
        return this.settings['SRTP-AuditTrail-ArchiveDelay'] ? this.settings['SRTP-AuditTrail-ArchiveDelay'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-AuditTrail-ArchiveDelay', 0, value)
      }
    },
    srtpAuditTrailArchiveDelayMonth : {
      get () {
        return this.settings['SRTP-AuditTrail-ArchiveDelay'] ? this.settings['SRTP-AuditTrail-ArchiveDelay'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-AuditTrail-ArchiveDelay', 1, value)
      }
    },
    srtpAuditTrailArchiveDelayDay : {
      get () {
        return this.settings['SRTP-AuditTrail-ArchiveDelay'] ? this.settings['SRTP-AuditTrail-ArchiveDelay'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-AuditTrail-ArchiveDelay', 2, value)
      }
    },
    srtpArchiveDelayYear : {
      get () {
        return this.settings['SRTP-ArchiveDelay'] ? this.settings['SRTP-ArchiveDelay'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-ArchiveDelay', 0, value)
      }
    },
    srtpArchiveDelayMonth : {
      get () {
        return this.settings['SRTP-ArchiveDelay'] ? this.settings['SRTP-ArchiveDelay'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-ArchiveDelay', 1, value)
      }
    },
    srtpArchiveDelayDay : {
      get () {
        return this.settings['SRTP-ArchiveDelay'] ? this.settings['SRTP-ArchiveDelay'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-ArchiveDelay', 2, value)
      }
    },
    srtpAuditTrailArchiveFrequenceYear : {
      get () {
        return this.settings['SRTP-AuditTrail-ArchiveFrequence'] ? this.settings['SRTP-AuditTrail-ArchiveFrequence'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-AuditTrail-ArchiveFrequence', 0, value)
      }
    },
    srtpAuditTrailArchiveFrequenceMonth : {
      get () {
        return this.settings['SRTP-AuditTrail-ArchiveFrequence'] ? this.settings['SRTP-AuditTrail-ArchiveFrequence'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-AuditTrail-ArchiveFrequence', 1, value)
      }
    },
    srtpAuditTrailArchiveFrequenceDay : {
      get () {
        return this.settings['SRTP-AuditTrail-ArchiveFrequence'] ? this.settings['SRTP-AuditTrail-ArchiveFrequence'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-AuditTrail-ArchiveFrequence', 2, value)
      }
    },
    srtpArchiveFrequenceYear : {
      get () {
        return this.settings['SRTP-ArchiveFrequence'] ? this.settings['SRTP-ArchiveFrequence'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-ArchiveFrequence', 0, value)
      }
    },
    srtpArchiveFrequenceMonth : {
      get () {
        return this.settings['SRTP-ArchiveFrequence'] ? this.settings['SRTP-ArchiveFrequence'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-ArchiveFrequence', 1, value)
      }
    },
    srtpArchiveFrequenceDay : {
      get () {
        return this.settings['SRTP-ArchiveFrequence'] ? this.settings['SRTP-ArchiveFrequence'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-ArchiveFrequence', 2, value)
      }
    },
    srtpAuditTrailLastArchive (){
      return this.$options.filters.formatDateTime(this.settings['SRTP-AuditTrail-LastArchive'])
    },
    srtpLastArchive (){
      return this.$options.filters.formatDateTime(this.settings.SRTP_LastArchive)
    },
    srtpAuditTrailLastPurge (){
      return this.$options.filters.formatDateTime(this.settings['SRTP-AuditTrail-LastPurge'])
    },
    srtpLastPurge (){
      return this.$options.filters.formatDateTime(this.settings.SRTP_LastPurge)
    },
    srtpAuditTrailPurgeDelayYear : {
      get () {
        return this.settings['SRTP-AuditTrail-PurgeDelay'] ? this.settings['SRTP-AuditTrail-PurgeDelay'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-AuditTrail-PurgeDelay', 0, value)
      }
    },
    srtpAuditTrailPurgeDelayMonth : {
      get () {
        return this.settings['SRTP-AuditTrail-PurgeDelay'] ? this.settings['SRTP-AuditTrail-PurgeDelay'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-AuditTrail-PurgeDelay', 1, value)
      }
    },
    srtpAuditTrailPurgeDelayDay : {
      get () {
        return this.settings['SRTP-AuditTrail-PurgeDelay'] ? this.settings['SRTP-AuditTrail-PurgeDelay'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-AuditTrail-PurgeDelay', 2, value)
      }
    },
    srtpPurgeDelayYear : {
      get () {
        return this.settings['SRTP-PurgeDelay'] ? this.settings['SRTP-PurgeDelay'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-PurgeDelay', 0, value)
      }
    },
    srtpPurgeDelayMonth : {
      get () {
        return this.settings['SRTP-PurgeDelay'] ? this.settings['SRTP-PurgeDelay'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-PurgeDelay', 1, value)
      }
    },
    srtpPurgeDelayDay : {
      get () {
        return this.settings['SRTP-PurgeDelay'] ? this.settings['SRTP-PurgeDelay'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-PurgeDelay', 2, value)
      }
    },
    srtpAuditTrailPurgeFrequenceYear : {
      get () {
        return this.settings['SRTP-AuditTrail-PurgeFrequence'] ? this.settings['SRTP-AuditTrail-PurgeFrequence'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-AuditTrail-PurgeFrequence', 0, value)
      }
    },
    srtpAuditTrailPurgeFrequenceMonth : {
      get () {
        return this.settings['SRTP-AuditTrail-PurgeFrequence'] ? this.settings['SRTP-AuditTrail-PurgeFrequence'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-AuditTrail-PurgeFrequence', 1, value)
      }
    },
    srtpAuditTrailPurgeFrequenceDay : {
      get () {
        return this.settings['SRTP-AuditTrail-PurgeFrequence'] ? this.settings['SRTP-AuditTrail-PurgeFrequence'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-AuditTrail-PurgeFrequence', 2, value)
      }
    },
    srtpPurgeFrequenceYear : {
      get () {
        return this.settings['SRTP-PurgeFrequence'] ? this.settings['SRTP-PurgeFrequence'].split(',')[0] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-PurgeFrequence', 0, value)
      }
    },
    srtpPurgeFrequenceMonth : {
      get () {
        return this.settings['SRTP-PurgeFrequence'] ? this.settings['SRTP-PurgeFrequence'].split(',')[1] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-PurgeFrequence', 1, value)
      }
    },
    srtpPurgeFrequenceDay : {
      get () {
        return this.settings['SRTP-PurgeFrequence'] ? this.settings['SRTP-PurgeFrequence'].split(',')[2] : '0'
      },
      set (value) {
        this.tripleParamSet('SRTP-PurgeFrequence', 2, value)
      }
    },
    role () {
      return this.tabName
    }
  },
  created() {
    this.environnments = [
      {"name": "development", "value": "4"},
      {"name": "qualification", "value": "3"},
      {"name": "staging", "value": "2"},
      {"name": "production", "value": "1"}
    ]
    this.getSettings()
  },
  methods: {
    changeMaxAmount(settingName) {
      if(this.settings[settingName]) {
        if (this.settings[settingName].includes('e')) {
          this.settings[settingName] = parseFloat(this.settings[settingName].split('e')[0]) * Math.pow(10, parseInt(this.settings[settingName].split('e')[1]))
        }
        if(this.settings[settingName].length > 16) {
          let partAfterVirgule = parseFloat('.' + this.settings[settingName].slice(this.settings[settingName].indexOf('.') + 1)).toFixed(2)
          partAfterVirgule = partAfterVirgule.substring(1)
          let partBeforeVirgule = this.settings[settingName].split('.')[0]
          this.settings[settingName] = partBeforeVirgule + partAfterVirgule
        } else {
          this.settings[settingName] = parseFloat(this.settings[settingName]).toFixed(2).toString()
        }
      } else {
        return
      }
    },
    changeMaxAmountHRTP() {
      this.changeMaxAmount('HRTP-RTPSPMaxAmount')
    },
    changeMaxAmountSRTP() {
      this.changeMaxAmount('SRTP-RTPSPMaxAmount')
    },
    changeMaxLinesExportRTP () {
      let newMonth = parseInt(this.settings['RTPMaxLinesExport'], 10).toString()
      if (newMonth === 'NaN' || !newMonth) {
        this.settings['RTPMaxLinesExport'] = this.originalSettings['RTPMaxLinesExport']
        this.resetInput = !this.resetInput
        return
      }
      this.settings['RTPMaxLinesExport'] = parseInt(this.settings['RTPMaxLinesExport'], 10).toString()
    },
    changeSettingInterval(value, stringParam) {
      let formatedValue

      formatedValue = value.replace(/[YM]/g, ',')
      formatedValue = formatedValue.replace(/[D]/g, '')
      this.settings[stringParam] = formatedValue
    },
    changeTimeBeforeExpSRTP() {
      if(this.settings.RTPSPTimeBeforeExpiration) {
        this.settings.RTPSPTimeBeforeExpiration = parseInt(this.settings.RTPSPTimeBeforeExpiration, 10).toString()
      } else {
        return
      }
    },
    changeVldityPeriodHRTP() {
      if(this.settings['HRTP-ValidityPeriod']) {
        this.settings['HRTP-ValidityPeriod'] = parseInt(this.settings['HRTP-ValidityPeriod'], 10).toString()
      } else {
        return
      }
    },
    controlMaxAmount (paramName) {
      let newAmount = parseFloat('.' + this.settings[paramName].slice(this.settings[paramName].indexOf('.') + 1)).toFixed(2)
      if (newAmount === 'NaN' || !newAmount) {
        this.settings[paramName] = this.originalSettings[paramName]
        this.resetInput = !this.resetInput
        return
      }
    },
    controlMaxAmountHRTP () {
      this.controlMaxAmount('HRTP-RTPSPMaxAmount')
    },
    controlMaxAmountSRTP () {
      this.controlMaxAmount('SRTP-RTPSPMaxAmount')
    },
    controlTimeBeforeExp (paramName) {
      let newTimer = parseInt(this.settings[paramName], 10).toString()
      if (newTimer === 'NaN' || !newTimer) {
        this.settings[paramName] = this.originalSettings[paramName]
        this.resetInput = !this.resetInput
        return
      }
    },
    controlTimeBeforeExpSRTP () {
      this.controlTimeBeforeExp('RTPSPTimeBeforeExpiration')
    },
    controlTimeBeforeExpHRTP () {
      this.controlTimeBeforeExp('HRTP-ValidityPeriod')
    },
    getSettings () {
      this.activateSpinner = true
      let that = this
      this.$engine.services.payments.fetchGlobalSettings().then((resp) => {
        that.settings = {...resp.data.GlobalRTPSettings}
        that.activateSpinner = false
        that.originalSettings = { ...that.settings }
      })
    },
    editSettings () {
      this.doesEdit = true
    },
    tripleParamSet (paramName, index, value) {
      let newVal = parseInt(value).toString()
      if (newVal === 'NaN') {
        this.resetInput = !this.resetInput
        newVal = this.originalSettings[paramName] ? this.originalSettings[paramName].split(',')[index] : '0'
      }
      let year = index === 0 ? newVal : (this.settings[paramName] ? this.settings[paramName].split(',')[0] : '0')
      let month = index === 1 ? newVal : (this.settings[paramName] ? this.settings[paramName].split(',')[1] : '0')
      let day = index === 2 ? newVal : (this.settings[paramName] ? this.settings[paramName].split(',')[2] : '0')
      this.settings[paramName] = year + ',' + month + ',' + day
    },
    hasRight (right) {
      return this.$engine.rights.rightIs(right, true)
    },
    resetSettings () {
      this.getSettings()
      this.doesEdit = false
    },
    updateSettings (settings) {
      let that = this

      // CHECK GLOBAL SETTINGS
      if (!this.settings['RTPMaxLinesExport']) {
        this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.max_lines_export')}))
        return
      }
      if (!this.settings['Environment']) {
        this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.environnment_type')}))
        return
      }

      // CHECK SRTP SETTINGS
      if (this.canSeeSRTP) {
        if (!this.settings.RTPSPIdentifier) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.rtp_identifier')}))
          return
        }
        // if (!this.settings['SRTP-API-AccountValidation']) {
        //   this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.rtp_api_accountvalidation')}))
        //   return
        // }
        if (!this.settings.RTPSPTimeBeforeExpiration) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.rtp_time_before_expiration')}))
          return
        }
        if (!this.settings['SRTP-RTPSPMaxAmount']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.max_amnt_srtp')}))
          return
        }
        if (!this.settings['SRTP-PurgeFrequence']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.srtp_purge_freq')}))
          return
        }
        if (!this.settings['SRTP-PurgeDelay']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.srtp_purge_delay')}))
          return
        }
        if (!this.settings['SRTP-ArchiveFrequence']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.srtp_archive_freq')}))
          return
        }
        if (!this.settings['SRTP-ArchiveDelay']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.srtp_archive_delay')}))
          return
        }
      }

      // CHECK HRTP SETTINGS
      if (this.canSeeHRTP) {
        if (!this.settings['HRTP-Identifier']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.hrtp_identifier')}))
          return
        }
        // if (!this.settings['HRTP-API-AccountValidation']) {
        //   this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.hrtp_api_accountvalidation')}))
        //   return
        // }
        if (!this.settings['HRTP-RTPSPMaxAmount']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.max_amnt_hrtp')}))
          return
        }
        if (!this.settings['HRTP-ValidityPeriod']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.rtp_h_validity_period')}))
          return
        }
        if (!this.settings['HRTP-PurgeFrequence']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.hrtp_purge_freq')}))
          return
        }
        if (!this.settings['HRTP-PurgeDelay']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.hrtp_purge_delay')}))
          return
        }
        if (!this.settings['HRTP-ArchiveFrequence']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.hrtp_archive_freq')}))
          return
        }
        if (!this.settings['HRTP-ArchiveDelay']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.hrtp_archive_delay')}))
          return
        }
      }

      // CHECK SRTP SETTINGS
      if (this.canSeePSD2) {
        if (!this.settings['PSD2-Token.io-JWT-Expiration']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.tokenio_jwt_expiration')}))
          return
        }
        if (!this.settings['PSD2-PurgeFrequence']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.psd2_purge_freq')}))
          return
        }
        if (!this.settings['PSD2-PurgeDelay']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.psd2_purge_delay')}))
          return
        }
        if (!this.settings['PSD2-ArchiveFrequence']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.psd2_archive_freq')}))
          return
        }
        if (!this.settings['PSD2-ArchiveDelay']) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.psd2_archive_delay')}))
          return
        }
      }

      let array = []
      let changedSettings = {}

      Object.keys(settings).forEach((key) => {
        if (settings[key] !== this.originalSettings[key]) {
          changedSettings[key] = settings[key]
        }
      })
      Object.entries(changedSettings).forEach((element) => {
        let object = {}
        object = {
          name: element[0],
          value: element[1],
        }
        array.push(object)
      })

      let data = array
      this.$engine.services.payments
        .updateGlobalSettings({ data })
        .then(() => {
          this.originalSettings = Object.assign({}, settings)
          this.doesEdit = false
          that.$f7.modal({
            title: that.$i18n.t("settings.settings_modified"),
            buttons: [
              {
                text: "OK",
                onClick: function () {
                  return
                },
              },
            ],
          })
          loadPage(that, { url: "/settings/rtpSettings/" })
        })
        .catch((e) => {
          let errMsgTitle = ''
          let errMsgDesc = ''
          if (e && e.response && e.response.data && e.response.data.error) {
            let errParsed = e.response.data.error.replace(/\s+/g, '')
            if (('errors._specific.title.' + errParsed) !== that.$t('errors._specific.title.' + errParsed)) {
              errMsgTitle = that.$t('errors._specific.title.' + errParsed)
              errMsgDesc = that.$t('errors._specific.description.' + errParsed)
            }
          }
          if (errMsgTitle && errMsgDesc) {
            that.$f7.alert(errMsgDesc, errMsgTitle)
          } else {
            errorMessageAlert(e, that)
          }
        })
    },
  },
}
</script>
